var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("skoly-menu", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _vm.profil.pouzivatel_id
        ? _c(
            "main",
            { staticClass: "profileDashboard position-relative pt-0" },
            [
              _c("img", {
                staticClass: "img-fluid position-absolute center-image",
                staticStyle: { "z-index": "1" },
                attrs: { src: "assets/img/ulohy-bg.jpg", alt: "" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "container pt-30 position-relative",
                  staticStyle: { "z-index": "10" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "row",
                      staticStyle: { "margin-bottom": "140px" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-md-12 col-lg-12 col-xl-4 offset-xl-2"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "m-skolskaKarta mb-30 pt-25 pb-25" },
                            [
                              _c(
                                "h5",
                                { staticClass: "a-skolskaKarta__title" },
                                [_vm._v("počet bodov")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "a-skolskaKarta__value text-success"
                                    },
                                    [
                                      _vm.profil.pouzivatel_id.pouzivatel_body
                                        ? [
                                            _vm._v(
                                              _vm._s(
                                                _vm.profil.pouzivatel_id
                                                  .pouzivatel_body
                                              )
                                            )
                                          ]
                                        : [_vm._v("0")]
                                    ],
                                    2
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-md-12 col-lg-12 col-xl-4"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "m-skolskaKarta mb-30 pt-25 pb-25" },
                            [
                              _c(
                                "h5",
                                { staticClass: "a-skolskaKarta__title" },
                                [_vm._v("vyplnené úlohy")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-between"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "a-skolskaKarta__value text-danger"
                                    },
                                    [_vm._v(_vm._s(_vm.uspesnost))]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.skolskeUlohy.length
                    ? _c(
                        "div",
                        { staticClass: "ulohy" },
                        [
                          _c("skoly-ulohy-row", {
                            attrs: {
                              "kvizova-uloha": null,
                              "tvoriva-uloha": null,
                              mesiac: _vm.mapaUloh.mesiace[0],
                              label: _vm.mapaUloh.labely[0],
                              profil: _vm.profil
                            }
                          }),
                          _vm._v(" "),
                          _vm._l(10, function(n, mesiac) {
                            return _c("skoly-ulohy-row", {
                              key: mesiac,
                              attrs: {
                                "kvizova-uloha": _vm.mapaUloh.kvizove[mesiac],
                                "tvoriva-uloha": _vm.mapaUloh.tvorive[mesiac],
                                mesiac: _vm.mapaUloh.mesiace[mesiac],
                                label: _vm.mapaUloh.labely[mesiac],
                                profil: _vm.profil
                              }
                            })
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }